class AccordionItem extends HTMLElement {
  constructor() {
    super();
    this.header = this.querySelector('.js-accordion-header');
    this.isOpen = false;
    
    if (this.header) {
      this.header.addEventListener('click', this.toggle.bind(this));
    }
  }
  
  toggle() {
    this.isOpen = !this.isOpen;
    this.classList.toggle('is-open', this.isOpen);
    this.header.setAttribute('aria-expanded', this.isOpen);
  }
}

if (!customElements.get('accordion-item')) {
  customElements.define('accordion-item', AccordionItem);
}
